export const DEFAULTS = Object.freeze({
  config: {
    alignment: 'center',
    size: 'content',
    showTitle: true,
    showDescription: true,
  },
});

export const SMALL_SIZE_WIDTH = 350;
export const SEO_IMAGE_WIDTH = 1000;
